import { render, staticRenderFns } from "./resetCode.vue?vue&type=template&id=60a8a09f"
import script from "./resetCode.vue?vue&type=script&lang=js"
export * from "./resetCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a8a09f')) {
      api.createRecord('60a8a09f', component.options)
    } else {
      api.reload('60a8a09f', component.options)
    }
    module.hot.accept("./resetCode.vue?vue&type=template&id=60a8a09f", function () {
      api.rerender('60a8a09f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/resetCode.vue"
export default component.exports